import React, { useState, useEffect, useRef } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getAllFiltersMDM,
  getMDMGraphData,
  getMDMKPIData,
} from "../../queries/apiQueries";
import { Button, SelectPicker, Modal, CheckPicker, Whisper, Tooltip, Checkbox } from "rsuite";
import "./industryInsights.scss";
import {
  FILTERDATA,
  TIMELINE,
  CURRENTVIEW,
  numberFormatter,
} from "../../utils";
import { projectType } from "../constants";
import InfoOutlineIcon from '@rsuite/icons/InfoOutline';
import { appInsights } from "../router";
import PotentialVsActualSales from "./potentialVsActualSales";
import SalesTrend from "./salesTrend";
import TopPotentialCustomers from "./topPotentialCustomers";
import MapView from "./map-view";
import moment from "moment";
import MainHeader from "../../components/Layouts/MainHeader";
import MainContent from "../../components/Layouts/MainContent";
import { Loader } from "../../components/common/Loader";
import { getTimelineOptions } from "../../config/constants";

const tabButton: any = {
  Category: "l2",
  District: "district",
  ['Customer Segment']: "NAICS_DESCRIPTION",
};

const IndustryInsights = (props: any) => {
  const dispatch = useDispatch<any>();
  const [filtersLoading, setFiltersLoading] = useState(true);
  const [buttonEnabled, setButtonEnabled] = useState(false);

  const [isVisible, setIsVisible] = useState(false);
  const [isRightVisible, setIsRightVisible] = useState(false);

  const allFilters = useSelector(
    (state: any) => state.CommonReducer.allFilters
  );
  const token = useSelector((state: any) => state.CommonReducer.token);
  const timeline = useSelector((state: any) => state.CommonReducer.timeline);
  const [graphData, setGraphData] = useState<any>([]);
  const [kpiData, setKPIData] = useState<any>([]);
  const [trendData, setTrendData] = useState<any>([]);
  const [mapGraphData, setMapGraphData] = useState<any>([]);
  const [yearFilter, setYearFilter] = useState<any>([]);
  const [showGraph,setShowGraph]=useState<any>({high:true,medium:true,low:true,graybar:true})

  const [selectedProjectType, setSelectedProjectType] = useState(
    projectType.length && projectType[2].value
  );

  const [selectedTimeline, setSelectedTimeline] = useState(
    timeline ? timeline : getTimelineOptions()[0]?.value
  );

  const [isLoading, setIsLoading] = useState(true);
  const [isGraphLoading, setIsGraphLoading] = useState(true);
  const [filterOptions, updateFilterOptions] = useState<any>({
    l1: new Array<{ l1: string }>(),
    l2: new Array<{ l2: string }>(),
    l3: new Array<{ l3: string }>(),
  });
  const [districtfilterOptions, setDistrictfilterOptions] = useState<any>({
    district: new Array<{ district: string }>(),
  });
  const [selectedDistrictFilter, setSelectedDistrictFilter] =
    useState<any>(null);

  const [selectedFilters, setSelectedFilters] = useState<any>(allFilters);
  const filtersMount: any = useRef(false);

  const [viewBy, setViewBy] = useState("Category");

  useEffect(() => {
    appInsights.trackPageView({
      name: `Navigate to supplier consolidation by ${localStorage.getItem(
        "name"
      )}`,
    });
    if (token) {
      getFilters();
      getMDMGraphDataHandler(selectedFilters);
      getMDMKPIDataHandler(selectedFilters);
    }
  }, [token, viewBy]);

  const getMDMGraphDataHandler = async (filters: any = null) => {
    setIsGraphLoading(true);
    let payload = {
      timeline: ["running12Month"],
      type: tabButton[viewBy],
    };
    payload = { ...filters, ...payload };
    let res = await dispatch(getMDMGraphData(payload));
    setGraphData(res);
    structureTrendData(res?.graph3);
    structureMapData(res?.graph4);
    setIsGraphLoading(false);
  };

    const structureMapData = (data: any) => {
    const high:any = [];
    const medium:any = [];
    const low:any = [];
    const graybar:any = [];

    data.forEach((city: any) => {
      if (city.overallGBShare <= city.gbmarketShare) {
        graybar.push(city);
      }
      if (city.cumulitivePer <= 20) {
        high.push(city);
      } else if (city.cumulitivePer > 20 && city.cumulitivePer <= 50) {
        medium.push(city);
      } else if (city.cumulitivePer > 50) {
        low.push(city);
      }
    });
    setMapGraphData({high:high,medium:medium,low:low,graybar:graybar})
    
  };

  const getMDMKPIDataHandler = async (filters: any = null) => {
    setIsLoading(true);
    let payload = filters;

    let res = await dispatch(getMDMKPIData(payload));
    setKPIData(res);
    setIsLoading(false);
  };

  /* Filters api call */
  const getFilters = async (
    payload: any = {},
    currentFilter: any = "all",
    fo: any = null
  ) => {
    // setFiltersLoading(true);
    if (Object.keys(payload).length > 0) {
      payload.projectType = selectedProjectType;
    }
    let res = await dispatch(getAllFiltersMDM(payload));

    if (currentFilter === "l2") {
      updateFilterOptions({ ...res, l2: filterOptions?.l2 });
    } else if (currentFilter === "district") {
      updateFilterOptions({ ...res, district: filterOptions?.district });
    } else if (currentFilter === "vertical") {
      updateFilterOptions({ ...res, vertical: filterOptions?.vertical });
    } else {
      updateFilterOptions(res);
    }

    setFiltersLoading(false);
    filtersMount.current = false;
    return res;
  };

  /* Updating filter selection state  */
  const handleFilterUpdate = (value: any, filter: string) => {
    filtersMount.current = true;
    let x: string = filter;
    setSelectedFilters({ ...selectedFilters, [x]: value });
    selectedFilters[x] = value;
  };

  /* Updating filter options based on selection (api) */
  const handleClose = (filter: string) => {
    setSelectedFilters(selectedFilters);
    getFilters(selectedFilters, "l1");
    getMDMGraphDataHandler(selectedFilters);
    getMDMKPIDataHandler(selectedFilters);
  };

  const handleClean = (filter: string) => {
    if (filter === "l2") {
      setSelectedFilters({ ...selectedFilters, l2: [] });
      getFilters({ ...selectedFilters, l2: [] }, "l2");
      getMDMGraphDataHandler({ ...selectedFilters, l2: [] });
      getMDMKPIDataHandler({ ...selectedFilters, l2: [] });
    } else if (filter === "district") {
      setSelectedFilters({ ...selectedFilters, district: [] });
      getFilters({ ...selectedFilters, district: [] }, "district");
      getMDMGraphDataHandler({ ...selectedFilters, district: [] });
      getMDMKPIDataHandler({ ...selectedFilters, district: [] });
    } else if (filter === "vertical") {
      setSelectedFilters({ ...selectedFilters, vertical: [] });
      getFilters({ ...selectedFilters, vertical: [] }, "vertical");
      getMDMGraphDataHandler({ ...selectedFilters, vertical: [] });
      getMDMKPIDataHandler({ ...selectedFilters, vertical: [] });
    }
  };

  /* on changing timeline */
  const timelineHandler = (e: any) => {
    setSelectedTimeline(e === null ? "All" : e);
  };

  const structureTrendData = (data: any) => {
    const yearsSet = new Set();
    data?.forEach((item: any) => {
      const year = moment.utc(item.monthStartDate).year();
      yearsSet.add(year);
    });
    const years = Array.from(yearsSet).sort();
    setYearFilter(years);
    const monthMap: any = {};

    data.forEach((item: any) => {
      const month = moment.utc(item.monthStartDate).format("MMM"); 
      const year = moment.utc(item.monthStartDate).year();
      if (!monthMap[month]) {
        monthMap[month] = {};
      }
      monthMap[month][year] = item.revenue;
    });

    const result = Object.keys(monthMap).map((month) => {
      const obj: any = { month };
      years.forEach((year: any) => {
        obj[year] = monthMap[month][year] || null; // null if no data for that year/month
      });
      return obj;
    });

    let last2025Index = -1,currentYear:any=years[years?.length-1],lastyear:any=years[years?.length-2];
    for (let i = 0; i < result.length; i++) {
      if (result[i][currentYear] !== null && result[i][currentYear] !== undefined) {
        last2025Index = i;
      }
    }

    const ratio = result[last2025Index][currentYear] / result[last2025Index][lastyear];
    result[last2025Index]['forecasted']=result[last2025Index][currentYear]
    for (let i = last2025Index + 1; i < result.length; i++) {
      if (result[i][currentYear] === null || result[i][currentYear] === undefined) {
        result[i]['forecasted'] = result[i][lastyear] * ratio;
      }
    }

    setTrendData(result);
  };

  console.log(trendData, "123");

  return isLoading || isGraphLoading ? (
    <Loader />
  ) : (
    <>
      <div className="supplier-consolidation-container w-full">
        <MainHeader
					onVisibilityChange={setIsVisible}
					isRightVisible={isRightVisible}
					setIsRightVisible={setIsRightVisible}
					topContent={
						<div className="flex justify-between items-center w-full">
							<div className="text-left pageline">
								<span className="pagelinestart textNormal">
									Baseline and Performance
								</span>{" "}
								<span className="pagelineslash textNormal">
									/
								</span>{" "}
								<span className="pagelinesub textNormal">
									Industry Insights
								</span>
							</div>
						</div>
					}
					bottomContent={
						<>
							{["l2", "district", "vertical"].map(
								(filterEntity: string, index: number) => {
									return (
										<div className="sub-heading-text font-bold flex flex-col items-start">
											<span className="filterHead textNormal">
												{filterEntity==='l2'?'Category':(filterEntity==='vertical'?'Customer Segment':filterEntity)}
											</span>
									 <CheckPicker
                      data={
                        filterOptions[filterEntity]?.length
                          ? filterOptions[filterEntity]
                          : []
                      }
                      placeholder="All"
                      labelKey={filterEntity}
                      valueKey={filterEntity}
                      value={
                        selectedFilters[filterEntity]
                          ? selectedFilters[filterEntity]
                          : []
                      }
                      onClose={() =>
                        filtersMount.current ? handleClose(filterEntity) : ""
                      }
                      onClean={() => {
                        handleClean(filterEntity);
                      }}
                      onChange={(value: any) =>
                        handleFilterUpdate(value, filterEntity)
                      }
                      loading={filtersLoading}
                    />
										</div>
									);
								}
							)}
						</>
					}
				></MainHeader>
      <MainContent isVisible={isVisible} fullHeight={true}>
          <div className="flex flex-col items-center w-full">
					<div className="flex justify-between gap-5 w-full mb-2">
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText"> Industry Revenue</span>
							</div>
							<div className="contentText">
							 {numberFormatter(kpiData?.industryRevenue, 0, "$")}
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">Graybar Revenue</span>
							</div>
							<div className="contentText">
								 {numberFormatter(kpiData?.gbRecenue, 0, "$")}
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">Market Share</span>
							</div>
							<div className="contentText">
								 {numberFormatter(kpiData?.share * 100, 0)} %
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">Gross Margin</span>
							</div>
							<div className="contentText">
								 {numberFormatter(kpiData?.grossMargin*100, 0)}%
							</div>
						</div>
						<div className="infocard">
							<div className="infocardHead">
								<span className="headerText">Opportunity</span>
							</div>
							<div className="contentText">
								{numberFormatter(kpiData?.opportunity, 0, "$")}
							</div>
						</div>
					</div>
				</div>
      
        <div
            className={`${
              !isVisible ? "h-[64vh]" : "h-[51vh]"
            } overflow-y-auto flex flex-col gap-[1vh]`}
          >

          <div className="flex-1 flex gap-[1vh] h-[60vh] w-full ">
            <div className="p-2 w-[49%] h-full grow-0 bg-white border-[0.5px] border-lightGrey">
              {/* Header */}
              <div className="headSpace">
                <div className="headContent">
                  Potential vs Actual Sale
                </div>
              </div>

              {/* Button Row */}
              <div className="flex gap-x-[2vh] ml-[1vh] my-[1vh]">
                {["Category", "District", "Customer Segment"].map((item) => (
                  <button
                    key={item}
                    onClick={() => setViewBy(item)}
                    className={`nav-items flex ${
                      viewBy === item ? "selected bg-[darkGreen]" : "bg-[gray]"
                    } text-white w-max px-[1vw] py-[0.5vh]`}
                  >
                    <span className="font-normal text-[0.8vw]">{item}</span>
                  </button>
                ))}
              </div>

              {/* Scrollable Table */}
              <div className="flex-1 overflow-auto h-[83%]">
                <PotentialVsActualSales data={graphData?.graph1} />
              </div>
             
            </div>

            <div className="suppliers-container p-2 w-[50%] grow-0 bg-white border-[0.5px] border-lightGrey">
              <div className="headSpace">
                <div className="headContent">
                  Graybar Sales Trend
                </div>
              </div>
              <div className="h-[98%]">
                <SalesTrend data={trendData} year={yearFilter} />
              </div>
            </div>
          </div>


          <div className="flex-1 flex gap-[1vh] h-[60vh] w-full">
            <div className="p-2 w-[49%] h-full grow-0 bg-white border-[0.5px] border-lightGrey">
            
              <div className="headSpace">
                <div className="headContent">
                  Graybar Coverage across Top MSAs
                </div>
              </div>
              <div className="h-[83%]">
                <MapView dataCity={mapGraphData} showGraph={showGraph} />
              </div>
              {/* <div className="relative h-10 overflow-hidden">
                <div className="absolute bottom-0 items-center left-0 w-full shadow-md pt-2 flex justify-center">
                  <div className="flex space-x-4">
                    <div className="w-3 h-3 bg-[#006400] shadow-md"></div>
                    <span className="text-[0.6vw]">High Opportunity Cities</span>
                    <div className="w-3 h-3 bg-[#F58427]  shadow-md"></div>
                    <span className="text-[0.6vw]">
                      Medium Opportunity Cities
                    </span>
                    <div className="w-3 h-3 bg-[#FFFFFF] shadow-md"></div>
                    <span className="text-[0.6vw]">Low Opportunity Cities</span>
                    <div className="-mt-1">
                      <svg width="24" height="24" viewBox="0 0 24 24">
                        <g transform="rotate(45 12 12)">
                          <rect x="11" y="6" width="2" height="12" fill="blue" />
                          <rect x="6" y="11" width="12" height="2" fill="blue" />
                        </g>
                      </svg>
                    </div>
                    <span className="text-[0.6vw]">Graybar</span>
                  </div>
                </div>
              </div> */}
              <div className="contentFooter h-10 overflow-hidden  !justify-between">
                <CustomLegend
                  showGraph = {showGraph}
                  updateShowGraph = {(value:any)=>{setShowGraph(value)}}
                ></CustomLegend>
              </div>
            </div>

            <div className="suppliers-container p-2 w-[50%] grow-0 bg-white border-[0.5px] border-lightGrey">
              {/* Header */}
                <div className="headSpace">
                <div className="headContent">
                 {`Potential Customer Market Share Opportunity by District`}
                </div>
              </div>
              {/* Scrollable Table */}
              <div className="flex-1 h-[83%]">
                <TopPotentialCustomers data={graphData?.graph2} />
              </div>

            </div>
          </div>

        </div>
      
      </MainContent>

      </div>
    </>
  );
};

const CustomLegend = (props:any) => {
  const {showGraph, updateShowGraph } = props;
  return (	
<div
		style={{
			display: "flex",
			gap: "1rem",
			alignItems: "center",
			color: "black",
			fontSize: "0.8rem",
		}}
	>
		<span className="flex gap-[1vh] items-center">
    <Checkbox  checked={showGraph?.high} onClick={(e:any)=>{updateShowGraph({...showGraph,high:e?.target?.checked})}}></Checkbox>
			<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					background: "#006400",
					marginRight: 8,
					verticalAlign: "middle",
				}}
			/>
			High Opportunity Cities
		</span>
     <Whisper
        placement="right"
        speaker={
          <Tooltip>
            <div>
            Cities contributing to the top 20% of industry sales are identified as high-potential cities.
            </div>
          </Tooltip>
        }
      >
        <InfoOutlineIcon className="!ml-[3px] mb-[.5vh]" />
      </Whisper>
    <span className="flex gap-[1vh] items-center">
    <Checkbox checked={showGraph?.medium} onClick={(e:any)=>{updateShowGraph({...showGraph,medium:e?.target?.checked})}}></Checkbox>
			<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					background: "#F58427",
					marginRight: 8,
					verticalAlign: "middle",
				}}
			/>
			Medium Opportunity Cities
		</span>
    <Whisper
      placement="right"
      speaker={
        <Tooltip>
          <div>
          Cities that contribute between 50% and 80% of industry sales are classified as medium-potential cities.

          </div>
        </Tooltip>
      }
    >
      <InfoOutlineIcon className="!ml-[3px] mb-[.5vh]" />
    </Whisper>
    {/* <span>
			<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					background: "#d2d1d1ff",
					marginRight: 8,
					verticalAlign: "middle",
				}}
			/>
			Low Opportunity Cities
		</span>
    <Whisper
      placement="right"
      speaker={
        <Tooltip>
          <div>
          Cities that contribute less than 50% of industry sales are classified as low-potential cities.
          </div>
        </Tooltip>
      }
    >
      <InfoOutlineIcon className="!ml-[3px] mb-[.5vh]" />
    </Whisper> */}
    <span className="flex gap-[1vh] items-center">
      <Checkbox checked={showGraph?.graybar} onClick={(e:any)=>{updateShowGraph({...showGraph,graybar:e?.target?.checked})}}></Checkbox>
      	<span
				style={{
					display: "inline-block",
					width: 10,
					height: 18,
					marginBottom:8,
					marginRight: 12,
					verticalAlign: "middle",
				}}
			>
        <svg width="24" height="24" viewBox="0 0 24 24">
          <g transform="rotate(45 12 12)">
            <rect x="11" y="6" width="2" height="12" fill="blue" />
            <rect x="6" y="11" width="12" height="2" fill="blue" />
          </g>
        </svg>
      </span>
      Graybar
    </span>
	</div>
  )
}

const mapDispatchToProps = (dispatch: any) => ({
  onFilterChange: (data: any) => {
    dispatch({ type: FILTERDATA, data: data });
    dispatch({
      type: CURRENTVIEW,
      data: {
        isSummaryView: true,
        viewBy: "Supplier",
        selectedHighlight: null,
        filters: {
          district: [],
          l1: [],
          l2: [],
          l3: [],
          supplier: [],
        },
      },
    });
  },
  onTimelineChange: (data: any) => dispatch({ type: TIMELINE, data: data }),
});
export default connect(null, mapDispatchToProps)(IndustryInsights);
